import { isString } from '../utils/string';
import slugifyLib from 'slugify';

export const slugifyText = (text: string | undefined) => {
  if (!isString(text)) return '';
  return slugifyLib(text || '', { lower: true, locale: 'de', strict: true });
};
